import { render, staticRenderFns } from "./elimination-series.vue?vue&type=template&id=8f2f1f42&scoped=true"
import script from "./elimination-series.vue?vue&type=script&lang=js"
export * from "./elimination-series.vue?vue&type=script&lang=js"
import style0 from "./elimination-series.vue?vue&type=style&index=0&id=8f2f1f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2f1f42",
  null
  
)

export default component.exports